import { AboutUs } from "../components";
import { Hero } from "../components";
import { OurServices } from "../components";
import { WorkDescription } from "../components";
import { OurReviews } from "../components";
import { Contact } from "../components";

const Home = () => {
	return (
		<>
			<Hero />
			<OurServices />
			<AboutUs />
			<WorkDescription />
			<OurReviews />
			<Contact />
		</>
	);
};

export default Home;
